import Services from './base-services'

const service = new Services('teachers/reportFilters')
import mapParameters from '../utils/map-parameters'

export default {
    getGeneralInformationForStudent(
        studentId: number,
        courseId: number,
        startDate: string,
        endDate: string,
    ) {
        const params = mapParameters({
            courseId,
            startDate,
            endDate,
            studentId,
        })
        return service.get(`generalInformationFiltered`, params, false)
    },
}
